import { useSearchParams, NavigateOptions } from 'react-router-dom';

export function useSearchParamsState(
  searchParamName: string,
  defaultValue: string
): readonly [
  searchParamsState: string,
  setSearchParamsState: (newState: string, options?: NavigateOptions) => void
] {
  const [searchParams, setSearchParams] = useSearchParams();

  const acquiredSearchParam = searchParams.get(searchParamName);
  const searchParamsState = acquiredSearchParam ?? defaultValue;

  const setSearchParamsState = (
    newState: string,
    options?: NavigateOptions
  ) => {
    const next = {
      ...Array.from(searchParams.entries()).reduce(
        (o, [key, value]) => ({ ...o, [key]: value }),
        {}
      ),
      [searchParamName]: newState,
    };
    setSearchParams(next, options);
  };
  return [searchParamsState, setSearchParamsState];
}
